import * as React from "react";
import { Component } from "react";
import { Layout, Modal } from "antd";
import SiderNav from "./pages/main/siderNav";
import MainContent from "./pages/main/mainContent";
import routes from "./assets/javascripts/routes";
import RouteWithSubRoutes from "./pages/main/routeWithSubRoutes";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { RootState } from "./core/reducers";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import ar from "./assets/locale/ar";
import de from "./assets/locale/de";
import en from "./assets/locale/en";
import es from "./assets/locale/es";
import fr from "./assets/locale/fr";
import hi from "./assets/locale/hi";
import ja from "./assets/locale/ja";
import ko from "./assets/locale/ko";
import pl from "./assets/locale/pl";
import pt from "./assets/locale/pt";
import ru from "./assets/locale/ru";
import zhHans from "./assets/locale/zh_Hans";
import zhHant from "./assets/locale/zh_Hant";

interface StateProps {
  appLoginStatus: boolean;
  invaildLogin: boolean;
}

type PropsType = RouteComponentProps & StateProps;

class App extends Component<PropsType> {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    document.title = "Right Gait & Posture";
  }

  componentDidMount() {
    let { appLoginStatus, history, invaildLogin } = this.props;
    let loginStatus = localStorage.getItem("status");
    let location = history.location;
    let pathname = location.pathname;
    let authorized = false;
    let url = "/login";
    routes.map((item) => {
      if (pathname === item.path && item.authorized) {
        authorized = true;
      }
    });
    if (!appLoginStatus && !loginStatus && authorized) {
      history.push(url);
    }
  }

  componentDidUpdate(prevProps) {
    let url = "/login";
    let { appLoginStatus, history, invaildLogin } = this.props;
    if (appLoginStatus !== prevProps.appLoginStatus) {
      if (!appLoginStatus) {
        if (invaildLogin) {
          Modal.error({
            content: "登录信息失效, 请重新登录!",
            okText: "知道了",
          });
        }
        history.push(url);
      }
    }
  }

  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  render() {
    const { history }: any = this.props;
    let pathname = history.location.pathname;
    let home: any;
    let ua = navigator.userAgent.toLocaleLowerCase();
    let isMobile = /mobi/i.test(ua);

    routes.map((route: any, i: any) => {
      if (route.authorized && pathname.search(route.path) === 0) {
        home = (
          <Layout>
            {!isMobile ? <SiderNav /> : null}
            <MainContent />
          </Layout>
        );
      }
    });

    let languageCode = (this.getQueryString("language") || "en").trim();
    if (languageCode.startsWith("zh_Hant") || ["zh_tw", "zh-HK", "zh-TW"].includes(languageCode)) {
      languageCode = "zh-Hant";
    } else if (languageCode.startsWith("zh_Hans") || ["zh", "zh-CN"].includes(languageCode)) {
      languageCode = "zh-Hans";
    } else if (languageCode.search("id") !== -1) {
      languageCode = "hi";
    }
    
    const language = {
      "zh-Hans": zhHans,
      "zh-Hant": zhHant,
      en: en,
      ar: ar,
      de: de,
      es: es,
      fr: fr,
      hi: hi,
      ja: ja,
      ko: ko,
      pl: pl,
      pt: pt,
      ru: ru,
    }[languageCode] || en;

    return (
      <IntlProvider locale={languageCode} messages={language}>
        <div className="App">
          {routes.map((route: any, i: any) => {
            if (!route.authorized) {
              return <RouteWithSubRoutes key={i} {...route} />;
            } else return null;
          })}
          {home}
        </div>
      </IntlProvider>
    );
  }
}

function mapStateToProps(state: RootState): StateProps {
  return {
    appLoginStatus: state.user.loginStatus,
    invaildLogin: state.user.invaildLogin,
  };
}

export default withRouter(connect(mapStateToProps)(App) as any);
